import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import configureTipTap from './plugins/tiptapVuetify'
import router from './router'
import store from './store'
import useFlashMessage from './composables/useFlashMessage'

import VeeValidate from 'vee-validate'
import appValidators from './validators'
import VueMask from 'v-mask'

import DisplayFilters from './components/filters'
import Vue2Filters from 'vue2-filters'
import LoggerPlugin from './plugins/loggerPlugin'
import './plugins/chartjs_plugins' // load chart plugins
import './plugins/vuelayers'

Vue.use(LoggerPlugin)

Vue.use(VueMask)
Vue.use(VeeValidate)
appValidators(VeeValidate.Validator)

Vue.use(DisplayFilters)
Vue.use(Vue2Filters)

Vue.config.productionTip = false

// wire up a  global error handler
Vue.prototype.$flash = useFlashMessage()

Vue.prototype.$copyright = `&copy 2019 - ${new Date().getFullYear()} Convynce`

/* eslint-disable no-extend-native */
Array.prototype.isArray = true // assign isArray property to array for easy testing if var isArray

configureTipTap(Vue, vuetify)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
